function clampPercent(value) {
  return Math.max(0, Math.min(100, Number(value) || 0));
}

export default function CourseProgressSummary({
  title,
  percent = 0,
  completed = 0,
  total = 0,
  tone = "blue",
  message = "",
  detail = "",
}) {
  const complete = clampPercent(percent) >= 100;
  const toneClass = tone === "green"
    ? "border-emerald-200 bg-emerald-50"
    : "border-sky-200 bg-sky-50";
  const barClass = tone === "green"
    ? "from-emerald-400 to-emerald-600"
    : "from-sky-400 to-blue-600";
  const messageClass = tone === "green" ? "text-emerald-700" : "text-sky-700";

  return (
    <section className={`rounded-2xl border p-5 ${toneClass}`}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 flex-1">
          <div className="text-xs font-extrabold uppercase tracking-[0.18em] text-slate-500">{title}</div>
          <div className="mt-2 text-4xl font-display font-extrabold text-[#0A2540]">{clampPercent(percent)}%</div>
          <div className="mt-2 text-sm font-semibold text-slate-700">{completed} of {total} {title.toLowerCase().includes("institute") ? "institute-managed steps" : "required student actions"} completed</div>
          <div className="mt-3 h-2 overflow-hidden rounded-full bg-white/80">
            <div className={`h-full bg-gradient-to-r ${barClass} transition-all`} style={{ width: `${clampPercent(percent)}%` }} />
          </div>
          {message && <p className={`mt-4 text-sm font-semibold ${messageClass}`}>{complete && tone === "green" ? `✓ ${message}` : message}</p>}
          {detail && <p className="mt-2 text-sm text-slate-600">{detail}</p>}
        </div>
      </div>
    </section>
  );
}
